<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28" fill="none">
    <path
      d="M16.5 0l7 7v15.6c0 2.25 0 3.375-.573 4.164a3 3 0 0 1-.663.663C21.475 28 20.349 28 18.1 28H5.9c-2.25 0-3.375 0-4.164-.573a3 3 0 0 1-.663-.663C.5 25.975.5 24.849.5 22.6V5.4c0-2.25 0-3.375.573-4.164a3 3 0 0 1 .663-.663C2.525 0 3.651 0 5.9 0h10.6z"
      fill="url(#paint0_linear_4691_45180)"
    />
    <path
      d="M16.5 0l7 7h-3.8c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16.5 5.48 16.5 4.92 16.5 3.8V0z"
      fill="#fff"
      fill-opacity=".55"
    />
    <path
      d="M8.203 11a.455.455 0 0 0-.37.717l2.986 4.224-3.236 4.592a.454.454 0 0 0 .372.716h1.25c.15 0 .29-.073.374-.197l2.415-3.507 2.428 3.508a.455.455 0 0 0 .374.196h1.25a.455.455 0 0 0 .37-.718l-3.26-4.59 3.01-4.222a.455.455 0 0 0-.37-.719h-1.249a.455.455 0 0 0-.374.196l-2.178 3.14-2.168-3.14A.455.455 0 0 0 9.453 11h-1.25z"
      fill="#fff"
    />
    <defs>
      <linearGradient id="paint0_linear_4691_45180" x1="1.5" y1="-1" x2="23.5" y2="28" gradientUnits="userSpaceOnUse">
        <stop stop-color="#84C768" />
        <stop offset="1" stop-color="#4BB477" />
      </linearGradient>
    </defs>
  </svg>
</template>
